import { Button, Divider, Skeleton, Table } from 'antd';
import API from 'API';
import React, { useEffect, useState } from 'react';
import dayjs from "dayjs";
import { formatVND, sum } from 'general_function';
import FullMask from 'components/layout/FullMask';

const orderStatus = [
    <span style={{ color: "blue " }}>Đang chờ thanh toán</span>,
    <span style={{ color: "green " }}>Đã thanh toán</span>,
    <span style={{ color: "red " }}>Đã huỷ</span>,
]

const columns = [
    { title: "Khởi tạo", key: "created_at", dataIndex: "created_at", render: value => dayjs(value).format("DD/MM/YYYY HH:mm:ss") },
    { title: "Số môn", key: "number_of_courses", dataIndex: "courses", render: value => value.length },
    { title: "Số tín chỉ", key: "credit", dataIndex: "courses", render: value => sum(value.map(item => item.credit)) },
    { title: "Tổng học phí", key: "tuition", dataIndex: "courses", render: (value, record) => formatVND(sum(value.map(item => item.credit)) * record.price) + " ₫" },
    { title: "Trạng thái", key: "status", dataIndex: "status", render: (value) => orderStatus[value] },
]

export default function Orders({ orders, setOrders, setCheckoutURL, setPayingOrder }) {
    const [loading, setLoading] = useState(true);
    const [getPayLink, setGetPayLink] = useState(false);
    useEffect(() => {
        API.get("/student/orders", { params: { page_size: 1000 } })
            .then(res => {
                setOrders(res.data.results);
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
            })
    }, [setOrders])
    return loading ? <Skeleton active /> :
        <div style={{ overflow: "auto", position: "relative" }}>
            {getPayLink && <FullMask page />}
            <Table
                rowKey={"id"}
                columns={[
                    ...columns,
                    {
                        key: "action", dataIndex: "id", render: (value, record) => {
                            if (record.status !== 0) return;
                            return <Button type='primary' onClick={() => {
                                setGetPayLink(true);
                                API.post("/student/get-payment-link/", { order_id: value })
                                    .then(res => {
                                        if (res.data.order.status === 0) {
                                            setCheckoutURL(res.data.checkout_url);
                                            setPayingOrder(record);
                                            return;
                                        }
                                        if (res.data.order.status === 1 || res.data.order.status === 2) {
                                            const index = orders.findIndex(item => item.id === value);
                                            orders[index] = res.data.order
                                            setOrders([...orders])
                                        }
                                    })
                                    .catch(error => {
                                        console.log(error);
                                    })
                                    .finally(() => {
                                        setGetPayLink(false);
                                    })
                            }}>
                                Thanh toán
                            </Button>
                        }
                    }
                ]}
                dataSource={orders}
                pagination={false}
                expandable={{
                    expandedRowRender: record => <><Table
                        rowKey={"id"}
                        columns={[
                            { title: "Mã môn", key: "code", dataIndex: "code" },
                            { title: "Môn học", key: "name", dataIndex: "name" },
                            { title: "Tín chỉ", key: "credit", dataIndex: "credit" },
                            { title: "Học phí", key: "tuition", dataIndex: "credit", render: value => formatVND(value*record.price) + " ₫"},
                        ]}
                        dataSource={record.courses}
                        pagination={false}
                    />
                    <Divider />
                    </>
                }}
            />
        </div>
}